import { IUserResponses } from 'types'

export const userResponsesManagerInitialState = {
  userResponses: null as IUserResponses,
  isLoadingResponses: undefined as boolean,
  isUpdatingResponse: false
}

export type UserResponsesManagerState = typeof userResponsesManagerInitialState
